module.exports = __webpack_public_path__ + "static/media/beachhouse.0d756be2.png";